import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { EMPTY_FILTERS } from "@/lib/constants";

const AppContext = createContext(null);

export function AppProvider({ children }) {
  const [meta, setMeta] = useState(null);
  const [filters, setFilters] = useState(EMPTY_FILTERS);
  const [complaintSentiment, setComplaintSentiment] = useState(["Negative"]);

  const refreshMeta = useCallback(async () => {
    const { data } = await api.get("/meta");
    setMeta(data);
  }, []);

  useEffect(() => {
    refreshMeta();
  }, [refreshMeta]);

  const activeBrand = filters.brand.length === 1 ? filters.brand[0] : "All";
  const setBrand = (b) => setFilters((f) => ({ ...f, brand: b === "All" ? [] : [b], outlet: [] }));

  return (
    <AppContext.Provider value={{ meta, refreshMeta, filters, setFilters, activeBrand, setBrand, complaintSentiment, setComplaintSentiment }}>
      {children}
    </AppContext.Provider>
  );
}

export const useApp = () => useContext(AppContext);
